import Restraint from "./Restraint.js";
import {v3} from "oc-threejs/short3";
import Maths3 from "oc-threejs/Maths3";
import AnchorAwareMixin from "./AnchorAwareMixin";

/**
 * Positioniert das Objekt vor Hindernissen
 */
export default class SurfaceRestraint extends AnchorAwareMixin(Restraint) {

    /** @type {THREE.Quaternion} */
    quaternionWorld;
    /** @type {THREE.Vector3} */
    faceNormal;
    // @deprecated synonym für options.freeOrientation
    /** @type {boolean} */
    freeOrientationAroundMainAxis;

    constructor(options) {
        super(options);
        this.freeOrientation = options.freeOrientation || options.freeOrientationAroundMainAxis || false;
    }

    setDefaultAnchorMatrix() {
        const offset = this.dragObject3dBoundingBoxLocal.getSize().multiply(Maths3.vector.y).multiplyScalar(-0.5);
        this.anchorMatrix = new THREE.Matrix4().setPosition(offset);
    }

    /**
     * @param {THREE.Raycaster} raycaster_
     * @returns {?{distance:number,point:THREE.Vector3,restraint:Restraint}}
     */
    raycastWorld(raycaster_) {

        const raycaster = raycaster_.clone();
        // if (this.anchor && this.dragObject3d) {
        //     raycaster.ray.origin.add(this.dragObject3d.getWorldPosition(v3()).sub(this.anchor.getWorldPosition(v3())));
        // }
        // raycaster.ray.origin.applyMatrix4(this.anchorMatrix);

        const intersects = raycaster.intersectObject( this.parentObject3D, true );

        if (intersects.length==0) {
            return null;
        }

        intersects.sort((a,b) => {
            return a.distance - b.distance;
        });

        const i = intersects[0];
        const point = i.point;
        this.faceNormal = i.face.normal;

        return {
            distance: raycaster.ray.origin.distanceTo(point),
            point,
            restraint: this,
        };

    }

    /**
     * @param {THREE.Object3D} dragObject3d
     * @param {THREE.Box3} dragObject3dBoundingBoxLocal
     */
    setDragObject3d(dragObject3d, dragObject3dBoundingBoxLocal) {
        super.setDragObject3d(dragObject3d,dragObject3dBoundingBoxLocal);
        this.quaternionWorld = new THREE.Quaternion();
        this.matrixWorld.decompose(v3(),this.quaternionWorld,v3());
    }


    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
        const faceNormalWorld = this.faceNormal.clone().applyQuaternion(this.quaternionWorld);
        const faceRayDot = raycaster.ray.direction.dot(faceNormalWorld);
        if (faceRayDot>0) {
            faceNormalWorld.negate();
        }

        if (this.freeOrientation) {
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix,v3(0,1,0)],
                to: [faceNormalWorld],
                rotate: true,
            });
        } else {
            const faceUpMatrix = Maths3.lookAtMatrix(new THREE.Matrix4(),faceNormalWorld,this.dragObject3d.up);
            faceUpMatrix.multiply(SurfaceRestraint.correctLookAtOrientationMatrix);
            Scenes.bring({
                what: [this.dragObject3d,this.anchorMatrix],
                to: [faceUpMatrix],
                rotate: true,
            });
        }

        Scenes.bring({
            what: [this.dragObject3d,this.anchorMatrix],
            to: [point],
            translate: true,
        });

    }

    static correctLookAtOrientationMatrix = new THREE.Matrix4().makeRotationFromQuaternion(Maths3.quaternion.x90.clone().multiply(Maths3.quaternion.y270));

}

